import { RootState } from '@reducers';

export const selectHealthPolicyDetails = (state: RootState) => state.userDashboardRouteReducer.policyDetailsReducer.healthPolicyDetailsReducer;
